import {registerPaymentMethod} from '@woocommerce/blocks-registry';
import {getSetting} from '@woocommerce/settings';
import {useState} from '@wordpress/element';
// import { usePaymentData } from '@woocommerce/blocks-checkout';
import { useEffect } from '@wordpress/element';

mameDtFrontendBlocks.gateways.forEach((id) => {

    // getSetting does not work for 'mame_dt_datatrans because it filters out _data.
    // See woocommerce-blocks/assets/js/settings/shared/utils.ts
    // https://github.com/woocommerce/woocommerce-blocks/blob/03c7cfacb225be345ab30240ef483476c080bae8/assets/js/settings/shared/utils.ts#L18
    // var settings = getSetting(id + '_data', {});

    const paymentMethodData = getSetting(
        'paymentMethodData',
        {}
    );

    let settings =
        id in paymentMethodData
            ? paymentMethodData[id]
            : {};

    if (Object.keys(settings).length !== 0) {

        var label;
        if (settings.icon.length) {
            label = <span className="wc-block-components-payment-method-label">
                {settings.title + ' '}
                <img src={settings.icon}/>
                </span>;
        } else {
            label = <span className="wc-block-components-payment-method-label">
                {settings.title + ' '}
                </span>;
        }

        const Content = (props) => {

            // Byjuno
            if (id === 'mame_dt_byjuno' || id === 'mame_dt_byjuno_2' || id === 'mame_dt_byjuno_3') {

                const {eventRegistration, emitResponse, billing} = props;
                const { onPaymentProcessing } = eventRegistration;

                const isBillingCompanyPresent = typeof billing?.billingAddress?.company === 'string' && billing?.billingAddress?.company?.trim().length > 0;
                const isPrivateCustomer = settings.customer_relationship === 'private' || (settings.customer_relationship === 'auto' && !isBillingCompanyPresent);
                let texts = settings.texts;

                useEffect( () => {
                    const checkAdditionalFields = onPaymentProcessing( async () => {

                        const gender = document.querySelector(`input[name="${id}-gender"]:checked`)?.value || '';
                        const day = document.querySelector(`input[name="${id}-day"]`)?.value || '';
                        const month = document.querySelector(`input[name="${id}-month"]`)?.value || '';
                        const year = document.querySelector(`input[name="${id}-year"]`)?.value || '';
                        const register_number = document.querySelector(`input[name="${id}-register_number"]`)?.value || '';

                        let isValid = isPrivateCustomer ? (gender && day && month && year) :register_number;

                        if ( isValid ) {
                            return {
                                type: emitResponse.responseTypes.SUCCESS,
                                meta: {
                                    paymentMethodData: {
                                        [`${id}-gender`]: gender,
                                        [`${id}-day`]: day,
                                        [`${id}-month`]: month,
                                        [`${id}-year`]: year,
                                        [`${id}-register_number`]: register_number,
                                    },
                                },
                            };
                        }

                        return {
                            type: emitResponse.responseTypes.ERROR,
                            message: isPrivateCustomer ? texts.missing_fields_private : texts.missing_fields_b2b,
                        };
                    } );

                    return () => checkAdditionalFields();
                }, [
                    emitResponse.responseTypes.ERROR,
                    emitResponse.responseTypes.SUCCESS,
                    onPaymentProcessing,
                ] );

                if (isPrivateCustomer) {
                    // Private

                    return (
                        <div className={`payment_box payment_method_${id}`}>
                            <fieldset id={`wc-${id}-gender-form`} className="wc-credit-card-form wc-payment-form">
                                <p>{texts.gender}</p>

                                <div style={{display: 'flex', gap: '2rem', alignItems: 'center'}}>
                                    <div className="form-row form-row-first">
                                        <input
                                            id={`${id}-gender-male`}
                                            type="radio"
                                            name={`${id}-gender`}
                                            value="male"
                                            style={{marginRight: '0.5rem'}}
                                        />
                                        <label htmlFor={`${id}-gender-male`}>
                                            {texts.male} <span className="required">*</span>
                                        </label>
                                    </div>

                                    <div className="form-row form-row-last">
                                        <input
                                            id={`${id}-gender-female`}
                                            type="radio"
                                            name={`${id}-gender`}
                                            value="female"
                                            style={{marginRight: '0.5rem'}}
                                        />
                                        <label htmlFor={`${id}-gender-female`}>
                                            {texts.female} <span className="required">*</span>
                                        </label>
                                    </div>

                                </div>
                            </fieldset>

                            <fieldset id={`wc-${id}-cc-form`} className="wc-credit-card-form wc-payment-form">
                                <p>{texts.birthdate}</p>

                                <div style={{display: 'flex', gap: '1rem'}}>

                                    <div style={{flex: 1}}>
                                        <label htmlFor={`${id}-day`}>
                                            {texts.day} <span className="required">*</span>
                                        </label>
                                        <input
                                            minLength="2"
                                            maxLength="2"
                                            type="tel"
                                            id={`${id}-day`}
                                            className="input-text wc-credit-card-form-card-number"
                                            inputMode="numeric"
                                            placeholder="••"
                                            name={`${id}-day`}
                                        />
                                    </div>

                                    <div style={{flex: 1}}>
                                        <label htmlFor={`${id}-month`}>
                                            {texts.month} <span className="required">*</span>
                                        </label>
                                        <input
                                            minLength="2"
                                            maxLength="2"
                                            type="tel"
                                            id={`${id}-month`}
                                            className="input-text wc-credit-card-form-card-number"
                                            inputMode="numeric"
                                            placeholder="••"
                                            name={`${id}-month`}
                                        />
                                    </div>
                                </div>
                                <div style={{marginTop: '1rem'}}>
                                    <label htmlFor={`${id}-year`} style={{display: 'block'}}>
                                        {texts.year} <span className="required">*</span>
                                    </label>
                                    <input
                                        minLength="4"
                                        maxLength="4"
                                        type="tel"
                                        id={`${id}-year`}
                                        className="input-text wc-credit-card-form-card-number"
                                        inputMode="numeric"
                                        placeholder="••••"
                                        name={`${id}-year`}
                                    />
                                </div>
                            </fieldset>
                        </div>
                    );

                } else {

                    // Company
                    // const [registerNumber, setRegisterNumber] = useState('');

                    return (
                        <div id="wc-mame_dt_byjuno-register_number-form" className="wc-payment-form">
                            <p className="form-row form-row-first woocommerce-validated">
                                <label htmlFor={`${id}-register_number`}>
                                    {settings.texts.commercial_register} <span className="required">*</span>
                                </label>
                                <br/>
                                <input
                                    type="text"
                                    id={`${id}-register_number`}
                                    className="input-text"
                                    placeholder=""
                                    name={`${id}-register_number`}
                                    // value={registerNumber}
                                    // onChange={(e) => setRegisterNumber(e.target.value)}
                                />
                            </p>
                            <div className="clear"></div>
                        </div>
                    );
                }

            }
        };

        const options = {
            name: id,
            label: label,
            ariaLabel: settings.title,
            // content: <div>{settings.description}</div>,
            content: <Content/>,
            edit: <div/>,
            canMakePayment: () => true,
            paymentMethodId: id,
            supports: {
                // features: ['products', 'refunds', 'elements'],  // Explicit!
                features: settings.supports,
            },
        };

        registerPaymentMethod(options);
    }

});